export enum TenMaxBeaconMessageType {
  TEXT = 'TEXT'
}

export type TenMaxBeaconMessageFormData = {
  type: TenMaxBeaconMessageType.TEXT;
  title: string;
  message: string;
  dataIOS: string;
  dataAndroid: string;
  bundleIds: string[];
};
